const sanitizeHtmlConfig = {
	allowedTags: [
		'p',
		'b',
		'i',
		'em',
		'u',
		'strong',
		'a',
		'img',
		'br',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6'
	],
	allowedAttributes: {
		p: ['style'],
		a: ['href', 'name', 'target'],
		img: ['src', 'srcset', 'alt', 'title', 'loading']
	}
}

export default sanitizeHtmlConfig
